import { useJwtHeaders } from '../../../hooks/useJwtHeaders';
import React, { FC, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import Optional from '../../Optional/Optional';
import axios from 'axios';
import { useNavigate } from 'react-router';
import './AdminMordyTotalsPage.scss';
import { calculateTotal } from '../../../helpers/calculateTotal';
import { setCustomer } from '../../../slices/customerSlice/customerSlice';
import camelcaseKeys from 'camelcase-keys';
import { getOrderAction } from '../../../actions/getOrderAction';

interface CustomerType {
  first_name: string;
  last_name: string;
}

interface AdminMordyType {
  hatzalah: boolean;
  amount: number;
  customer: CustomerType;
  id: number;
  order_id: number;
}

const AdminMordyTotalsPage: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const headers = useJwtHeaders();
  const admin = useSelector<RootState, boolean>(({ user }) => user.admin!);
  const [mordys, setMordys] = useState([] as AdminMordyType[]);

  useMemo(() => {
    axios.get(`/api/v1/admin/mordys`, headers).then(({ data }) => {
      setMordys(data);
    });
  }, []);

  const hatzalahMordies = mordys.filter(mordy => mordy.hatzalah);
  const nonHatzalahMordies = mordys.filter(mordy => !mordy.hatzalah);
  const total = calculateTotal(nonHatzalahMordies, 'amount');

  const handleClick = (orderId, customer) => {
    dispatch(setCustomer(camelcaseKeys(customer)));
    dispatch(getOrderAction(orderId, navigate, headers));
  };

  return (
    <div className="admin-order-page">
      <Optional renderIf={admin}>
        <table className="table table-hover table-striped">
          <thead>
            <tr>
              <th scope="col">Order # ({mordys.length})</th>
              <th scope="col">Name</th>
              <th scope="col">Discount Amount (${total})</th>
            </tr>
          </thead>
          <tbody>
            {nonHatzalahMordies.map(mordy => (
              <tr key={`mordy-${mordy.id}`} onClick={() => handleClick(mordy.order_id, mordy.customer)}>
                <td>{mordy.order_id}</td>
                <td>{`${mordy.customer.first_name} ${mordy.customer.last_name}`}</td>
                <td>${mordy.amount}</td>
              </tr>
            ))}
            <tr>
              <b>======== HATZALAH ========</b>
            </tr>
            {hatzalahMordies.map(mordy => (
              <tr key={`mordy-${mordy.id}`} onClick={() => handleClick(mordy.order_id, mordy.customer)}>
                <td>{mordy.order_id}</td>
                <td>{`${mordy.customer.first_name} ${mordy.customer.last_name}`}</td>
                <td>${mordy.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Optional>
      <Optional renderIf={!admin}>
        <b>YOU MUST BE AN ADMIN TO VIEW THIS PAGE</b>
      </Optional>
    </div>
  );
};

export default AdminMordyTotalsPage;
